import React, { useState, useEffect, useMemo, useCallback } from 'react';
import './index.less';
import { Spin, Empty, Button, Typography, Tooltip, Popover, Pagination, PaginationProps, Tabs } from 'antd';
import { strategyItem } from '../index';
const { Paragraph } = Typography;

enum PromotionIdType {
  // 总价促销
  promotion = 17,
  // 优惠券
  coupon = 32,
}

export default function SalePlaySelectCardsTab(props: {
  planCode: string;
  toSalePlaySelect: any;
  toSalePlaySelectAndPromotionId: any;
  listinfo: {
    loading: boolean;
    list: strategyItem[];
  };
}) {
  const { listinfo } = props;
  const [tabs, setTabs] = useState<{ selectProducts: strategyItem[] | []; selectShops: strategyItem[] | [] }>({
    selectProducts: [],
    selectShops: [],
  });
  useEffect(() => {
    let selectProducts: strategyItem[] = [];
    let selectShops: strategyItem[] = [];
    listinfo?.list?.map((item: strategyItem) => {
      if (item?.materialType === '5') {
        selectShops.push(item);
      } else {
        selectProducts.push(item);
      }
    });
    setTabs({ selectProducts: selectProducts, selectShops: selectShops });
  }, [listinfo]);
  return (
    <Tabs defaultActiveKey="1">
      <Tabs.TabPane tab="选品" key="1">
        <SalePlaySelectCards {...props} listinfo={{ loading: listinfo.loading, list: tabs.selectProducts }} />
      </Tabs.TabPane>
      <Tabs.TabPane tab="选店" key="2">
        <SalePlaySelectCards {...props} listinfo={{ loading: listinfo.loading, list: tabs.selectShops }} />
      </Tabs.TabPane>
    </Tabs>
  );
}

function SalePlaySelectCards({
  planCode,
  toSalePlaySelect,
  toSalePlaySelectAndPromotionId,
  listinfo,
}: {
  planCode: string;
  toSalePlaySelect: any;
  toSalePlaySelectAndPromotionId: any;
  listinfo: {
    loading: boolean;
    list: strategyItem[];
  };
}) {
  const [current, setCurrent] = useState(1);
  const [pageList, setPageList] = useState<strategyItem[]>([]);
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [size, setSize] = useState(3);

  useEffect(() => {
    setPageList(listinfo?.list?.slice(0, size));
  }, [listinfo, size]);

  const onChange = useCallback(
    (val: number) => {
      setCurrent(val);
      setPageList(listinfo?.list?.slice((val - 1) * size, val * size));
    },
    [size, listinfo]
  );

  useEffect(() => {
    const num = Math.floor((width - 280) / 275);
    setSize(num);
  }, [width]);

  const resizeWidth = (e: any) => {
    const w = e.target.innerWidth;
    setWidth(w);
  };

  useEffect(() => {
    const w = window.innerWidth;
    setWidth(w);
    window.addEventListener('resize', resizeWidth);
    return () => {
      window.removeEventListener('resize', resizeWidth);
    };
  }, []);

  const showTotal: PaginationProps['showTotal'] = (total) => `总共 ${total} 条`;

  const renderFooter = useMemo(() => {
    return (
      <div className="common-strategy-footer">
        <Pagination
          size="small"
          total={listinfo.list.length}
          showTotal={showTotal}
          pageSize={size}
          current={current}
          onChange={onChange}
        />
      </div>
    );
  }, [size, listinfo.list, current, onChange]);

  const renderBtn = (item: strategyItem) => {
    if (item?.materialType === '5') {
      return (
        <Button type="primary" ghost onClick={() => toSalePlaySelect(Number(item.poolType), item.materialType)}>
          去选店
        </Button>
      );
    }
    return PromotionIdType.coupon === Number(item.poolType) || PromotionIdType.promotion === Number(item.poolType) ? (
      <Button
        type="primary"
        ghost
        onClick={() => toSalePlaySelectAndPromotionId({ poolType: item.poolType, planCode })}
      >
        去选品
      </Button>
    ) : (
      <Button type="primary" ghost onClick={() => toSalePlaySelect(Number(item.poolType), item.materialType)}>
        去选品
      </Button>
    );
  };

  return (
    // @ts-ignore
    <Spin spinning={listinfo.loading}>
      {listinfo?.list && listinfo?.list?.length ? (
        <div className="sale-play-select-cards-list">
          {pageList.map((item: any, index) => {
            return (
              <div key={index} className="sale-play-select-card" style={{ background: item.background }}>
                <div className="card-content">
                  <div className="content-desc">
                    <div className="desc-title">{item.name}</div>
                    <Paragraph className="desc-text" ellipsis={{ rows: 2 }}>
                      <Tooltip title={item.description}>{item.description}</Tooltip>
                    </Paragraph>
                    <div className="scene-title">适用场景：{item.scene}</div>
                  </div>
                  <Popover content={<img src={item.picUrl} className="cards-list-popover-img" />}>
                    <img src={item.picUrl} className="cards-list-img" />
                  </Popover>
                </div>
                <div className="card-footer">{renderBtn(item)}</div>
              </div>
            );
          })}
        </div>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
      {renderFooter}
    </Spin>
  );
}
